<template>
    <!-- 하다희 신규 - 예약기록 -->
    <div class="pop_overlay_black" v-if="isShow">
        <div class="pop_wrap rsv2_manager_set_pop" style="width: 915px;">
            <div class="pop_title">
                <span class="title">{{ $t('popup_reservation_history.title') }}</span>
                <button class="mgl_auto" @click="action_ClosePopup">
                    <v-icon large>mdi-close</v-icon>
                </button>
            </div>

            <div class="pop_desc lgray black_txt" style="border-bottom: 1px solid var(--gray60)">
                {{ $t('popup_reservation_history.sub_title') }}
            </div>

            <div class="pop_cont">
                <!-- 검색 필터 -->
                <SearchFilter
                    :value="filter"
                    :placeholder="$t('popup_reservation_history.placeholder_search')"
                    :button_text="$t('popup_reservation_history.button_search')"
                    @search="search"
                />
                <!-- 결과 테이블 -->
                <HistoryTable
                    :results="results"
                />
                <Pagenation
                    :totalCount="totalCount"
                    :currentPage="currentPage"
                    :countPerPage="countPerPage"
                    :countPerRow="countPerRow"
                    @changePage="loadPageIndex"
                />
            </div>
        </div>
    </div>
</template>


<script>
import { deepCopy } from '@/util/deep-copy'
import SearchFilter from './ReservationHistorySearchFilter.vue'
import HistoryTable from './ReservationHistoryTable.vue'
import Pagenation from '../../../../ShareComponents/PagenationComponent.vue'

import { closeReservationHistoryPopup, sheetOverlays } from '../../../sheet-overlays'
import { useQueryClient } from '@tanstack/vue-query'
import { isApiErrorWithCode } from '@/apis/instances/check-api-response'
import { v2HReservationFindQueryOptions } from '@/composables/queries/v2hreservation/use-v2-hreservation-find-query'
import { v2HReservationCountQueryOptions } from '@/composables/queries/v2hreservation/use-v2-hreservation-count-query'

export default {
    setup() {
        const queryClient = useQueryClient()
        return { queryClient }
    },
    components: {
        SearchFilter, HistoryTable,
        Pagenation
    },
    data() {
        return {
            sheetOverlays,

            filter: undefined,
            results: [],
            isPageLoading: false,

            totalCount: 0,
            countPerPage: 30,
            countPerRow: 5,
            currentPage: 0,

        }
    },
    watch: {
        isShow: {
            handler: function (newValue) {
                if (newValue) {
                    this.addEventListener()
                    this.filter = {
                        hospitalID: this.hospital.selectedHospital._id,
                        key: 'createdAt',
                        way: -1
                    }
                    this.loadData()
                } else {
                    this.removeEventListener()
                }
            }
        },
    },
    computed: {
        isShow: function () {
            return this.sheetOverlays.isShowReservationHistoryPopup
        }
    },
    methods: {
        action_ClosePopup() {
            closeReservationHistoryPopup()
        },
        action_SelectReservation() {
            // TODO: select reservation - for move to date, selection
        },
        handleKeyUp(e) {
            if (e.keyCode == 27) {
                this.action_ClosePopup()
            }
        },
        addEventListener() {
            window.addEventListener('keyup', this.handleKeyUp)
        },
        removeEventListener() {
            window.removeEventListener('keyup', this.handleKeyUp)
        },
        // MARK: - Network
        // 구 PageController(봉투 어댑터 포함) 해체 — 페이지 상태를 컴포넌트가 직접 관리한다
        normalizedFilter() {
            let f = deepCopy(this.filter)
            if (f.filterkey == 'writerName') {
                delete f.keyword
            } else if (!f.keyword) {
                delete f.filterkey
                delete f.keyword
            }
            return f
        },
        async loadData() {
            await this.loadHistoriesCount()
            await this.loadPageIndex(0)
        },
        async loadHistoriesCount() {
            let f = this.normalizedFilter()
            delete f.key
            delete f.way
            try {
                this.totalCount = await this.queryClient.fetchQuery(v2HReservationCountQueryOptions(f))
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 중단
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
            }
        },
        async loadPageIndex(index) {
            if (this.isPageLoading) { return }
            this.isPageLoading = true
            this.currentPage = index
            let f = this.normalizedFilter()
            f.skip = index * this.countPerPage
            f.limit = this.countPerPage
            try {
                this.results = await this.queryClient.fetchQuery(v2HReservationFindQueryOptions(f))
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 빈 목록 표시
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
                this.results = []
            } finally {
                this.isPageLoading = false
            }
        },


        // MARK: - Emit
        search(filter) {
            this.filter = filter
            this.loadData()
        }
    }
}
</script>

<style scoped>
.pop_cont .row1 {
    display: flex;
    margin-bottom: 20px
}

.pop_cont tr {
    background-color: white;
}
</style>